import { createFileRoute } from "@tanstack/react-router";
import SBOPDemographicForm from "@/pages/SBOPDemographicForm";

export const Route = createFileRoute("/accelerator/sbop/")({
  component: SBOPDemographicForm,
});
